:host {
  display: flex;
  flex-direction: column;
  gap: $xp-ref-spacing-2;
  border: 1px solid $xp-ref-color-border-medium;
  padding: $xp-ref-spacing-3;
  background-color: transparent;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.order-overview {
  display: flex;
  flex-direction: column;
  gap: $xp-ref-spacing-2;

  .order {
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    padding: $xp-ref-spacing-2 0 $xp-ref-spacing-2 0;

    .item:nth-child(1),
    .item:nth-child(2) {
      font: $xp-ref-font-label-label-short;
      color: $xp-ref-color-text-default-dark;
    }

    .item:nth-child(3) {
      font: $xp-ref-font-paragraph-paragraph-small;
      color: $xp-ref-color-text-default-medium;
    }

    .item:nth-child(1),
    .item:nth-child(3) {
      justify-self: flex-start;
      text-align: left;
    }
    .item:nth-child(2) {
      justify-self: flex-end;
      text-align: right;
    }
  }
}

.sum-overview {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  border-top: 1px solid $xp-ref-color-border-medium;
  padding: $xp-ref-spacing-2 0 0 0;

  .item:nth-child(1),
  .item:nth-child(2) {
    font: $xp-ref-font-headline-headline04;
    color: $xp-ref-color-text-default-dark;
  }

  .item:nth-child(3),
  .item:nth-child(4) {
    font: $xp-ref-font-paragraph-paragraph-small;
    color: $xp-ref-color-text-default-medium;
  }

  .item:nth-child(1),
  .item:nth-child(3) {
    justify-self: flex-start;
    text-align: left;
  }

  .item:nth-child(2),
  .item:nth-child(4) {
    justify-self: flex-end;
    text-align: right;
  }
}
